<template>
  <div
    class="recommenLive"
    :style="{ height: `${windowHeight / 16 - 9}rem`, overflow: 'auto' }"
  >
    <div>
      <el-carousel height="195px" indicator-position="none">
        <el-carousel-item v-for="(item, key) in advertisementsList" :key="key">
          <img
            @click="gotoURL(item.link)"
            :src="item.url"
            style="width: 100%; border-radius: 5px"
          />
        </el-carousel-item>
      </el-carousel>
    </div>
    <div
      class="infinite-list"
      :infinite-scroll-immediate="false"
      infinite-scroll-distance="5"
      v-infinite-scroll="load"
      :style="{ padding: '0.5rem 0rem', display: 'flex', flexWrap: 'wrap' }"
    >
      <div
        v-for="(item, key) in contentInfoList"
        :key="key"
        style="width: 49%; margin-right: 1%"
        @click="handleDetail(item.id, InfoObject.code)"
      >
        <div style="position: relative">
          <img
            :src="item.cover | getImageURL"
            style="
              width: 100%;
              border-radius: 10px;
              min-height: 100px;
              background: #e1e1e1;
            "
          />
          <div
            v-if="item.tag"
            style="
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              position: absolute;
              left: 0px;
              top: 0px;
            "
          >
            {{ item.tag }}
          </div>
          <div style="position: absolute; left: 10px; bottom: 10px">
            <div
              v-if="item.status == 'LIVE'"
              style="
                display: flex;
                border-radius: 5px;
                color: #fff;
                font-size: 12px;
                background: rgba(1, 1, 1, 0.3);
              "
            >
              <div
                style="
                  background-color: rgba(255, 51, 102, 1);
                  border-radius: 5px;
                  width: 48px;
                  height: 25px;
                  line-height: 25px;
                  text-align: center;
                "
              >
                直播中
              </div>
              <div style="margin: 0px 10px; height: 25px; line-height: 25px">
                {{ item.playNumber | formatReadNumber }}观看
              </div>
            </div>
            <div
              v-if="item.status == 'RESERVATION'"
              style="
                display: flex;
                border-radius: 5px;
                color: #fff;
                font-size: 12px;
                background: rgba(1, 1, 1, 0.3);
              "
            >
              <div
                style="
                  background-color: rgba(255, 204, 51, 1);
                  border-radius: 5px;
                  width: 48px;
                  height: 25px;
                  line-height: 25px;
                  text-align: center;
                "
              >
                预约
              </div>
              <div style="margin: 0px 10px; height: 25px; line-height: 25px">
                {{ item.playNumber | formatReadNumber }}人想看
              </div>
            </div>
            <div
              v-if="item.status == 'LOOK_BACK'"
              style="
                display: flex;
                border-radius: 5px;
                color: #fff;
                font-size: 12px;
                background: rgba(1, 1, 1, 0.3);
              "
            >
              <div
                style="
                  background-color: rgba(153, 153, 204, 1);
                  border-radius: 5px;
                  width: 48px;
                  height: 25px;
                  line-height: 25px;
                  text-align: center;
                "
              >
                回看
              </div>
              <div style="margin: 0px 10px; height: 25px; line-height: 25px">
                {{ item.playNumber | formatReadNumber }}观看
              </div>
            </div>
          </div>
        </div>
        <div
          class="ellipsisT"
          style="margin-top: 5px; font-size: 16px; height: 40px"
        >
          {{ item.title }}
        </div>
        <div style="display: flex; text-align: center; margin: 15px 0px">
          <span
            style="
              color: #ffae18;
              font-size: 12px;
              background: rgba(255, 241, 240, 1);
              padding: 0px 10px;
              border-radius: 5px;
              margin-right: 10px;
            "
            >社会</span
          >
          <span style="color: #888888;font-size:13px">{{ item.authorName }}</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import * as request from "@/utils/request";
import { getImageURL as _getImageURL } from "@/utils/zgly-utils.js";
export default {
  components: {},
  created() {},
  mounted() {
    this.windowHeight = document.documentElement.clientHeight;
    this.getInfoClass();
    request
      .getPosters({
        type: "LIVE_CAROUSEL",
      })
      .then((res) => {
        if (res.code == 0) {
          this.advertisementsList = res.data;
        }
      });
  },
  data() {
    return {
      VUE_APP_BASE_API: "https://www.my100000.com:9080/",
      contentInfoList: [],
      advertisementsList: [],
      windowHeight: 0, //实时屏幕高度
      page: 0,
      InfoObject: {},
    };
  },
  filters: {
    formatReadNumber(val) {
      return val > 10000 ? `${(val / 10000).toFixed(2)}万` : val;
    },
    getImageURL(cover) {
      return _getImageURL(cover, "https://www.my100000.com:9080/");
    },
  },
  computed: {},
  methods: {
    load() {
      this.page = this.page + 1;
      this.initList();
    },
    initList() {
      request
        .getResourceLivesRecommended({
          page: this.page,
          size: 10,
        })
        .then((res) => {
          if (res.code == 0) {
            this.contentInfoList = [...this.contentInfoList, ...res.data];
          }
        });
    },
    getInfoClass() {
      request.getDicts().then((res) => {
        this.InfoObject = res.data.filter((item) => item.value === "直播")[0];
      });
    },
    handleDetail(id, type) {
      this.$router.push({ path: `/live/player/${id}?type=${type}` });
    },
    gotoURL(url) {
      window.location.href = url;
    },
  },
};
</script>
<style lang="less">
.recommenLive {
  margin: 0rem 0.3rem;
  .recommenLiveTitle {
    display: flex;
    justify-content: space-between;
    margin: 0.5rem 0rem;
    font-size: 1.2rem;
  }
  .recommenLiveContent {
    font-size: 0.9rem;
  }
  .ellipsisT {
    letter-spacing: 0;
    overflow: hidden;
    display: -webkit-box;
    text-overflow: ellipsis;
    -webkit-line-clamp: 2; /*要显示的行数*/
    -webkit-box-orient: vertical;
  }
}
</style>